'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContactService = function () {
  function ContactService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ContactService);
    this.$http = $http;
    this.appConfig = appConfig;
  }

  (0, _createClass3.default)(ContactService, [{
    key: 'getContact',
    value: function getContact(entityId, contactId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/get/' + entityId + '/' + contactId));
    }
  }, {
    key: 'editContact',
    value: function editContact(contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/edit', contact);
    }
  }, {
    key: 'quickEdit',
    value: function quickEdit(contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/contact/quickedit', contact);
    }
  }, {
    key: 'listContacts',
    value: function listContacts(filterParams) {
      var query = '';

      query += '?pageStart=' + filterParams.pageCriteria.pageStart;
      query += '&itemsToFetch=' + filterParams.pageCriteria.itemsToFetch;
      query += '&sortExpression=' + filterParams.pageCriteria.sortExpression;
      query += '&ascending=' + filterParams.pageCriteria.ascending;
      query += '&entityId=' + filterParams.entityId;

      if (filterParams.contactType) {
        query += '&contactType=' + filterParams.contactType;
      }

      if (filterParams.contactName) {
        query += '&contactName=' + filterParams.contactName;
      }

      if (filterParams.companyName) {
        query += '&companyName=' + filterParams.companyName;
      }

      if (filterParams.ownerName) {
        query += '&ownerName=' + filterParams.ownerName;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/contact/list' + query);
    }
  }, {
    key: 'updateContactState',
    value: function updateContactState(entityId, contactId, state) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/update/' + entityId + '/' + contactId + '/' + state));
    }
  }, {
    key: 'searchContacts',
    value: function searchContacts(entityId, searchTerm) {
      var query = '?entityId=' + entityId;

      if (searchTerm) {
        query += '&searchTerm=' + searchTerm;
      }

      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/search' + query));
    }
  }, {
    key: 'viewContact',
    value: function viewContact(entityId, contactId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/view/' + entityId + '/' + contactId));
    }
  }, {
    key: 'addEvent',
    value: function addEvent(contactId, contactMethod, handledBy, enquiryId) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/addEvent/' + contactId + '/' + contactMethod + '/' + handledBy + '/' + enquiryId));
    }
  }, {
    key: 'updateDpa',
    value: function updateDpa(entityId, dpa) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/updatedpa/' + entityId), dpa);
    }
  }, {
    key: 'updateAllDpa',
    value: function updateAllDpa(entityId, dpa) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/updatealldpa/' + entityId), dpa);
    }
  }, {
    key: 'addNote',
    value: function addNote(entityId, contactId, noteText) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + ('api/contact/addNote/' + entityId + '/' + contactId), { text: noteText });
    }
  }, {
    key: 'updateOwner',
    value: function updateOwner(contactId, ownerId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/updateOwner/' + contactId + '/' + ownerId));
    }
  }, {
    key: 'anonymize',
    value: function anonymize(contactId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/anonymize/' + contactId));
    }
  }, {
    key: 'exportContactsToTelecomProvider',
    value: function exportContactsToTelecomProvider(entityId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/exportContactsToTelecomProvider/' + entityId));
    }
  }, {
    key: 'getCallLog',
    value: function getCallLog(contactLifeCycleId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + ('api/contact/getcalllog/' + contactLifeCycleId));
    }
  }]);
  return ContactService;
}();

exports.default = ContactService;


// WEBPACK FOOTER //
// ./client/app/components/contact/contact.service.js